module.exports = __webpack_public_path__ + "img/faro-hotel.0cd3991d.jpg";